import { useQuery, useMutation, useQueryClient } from 'react-query';
import * as surveyIntegrationApi from 'src/api/surveyIntegration';
import { UserStoreObject } from 'src/stores/UserStore';

const getOrgId = () => UserStoreObject.selectedOrg?.orgId;

export const surveyIntegrationConfigKey = (orgId: number | undefined) =>
    ['surveyIntegrationConfig', orgId] as const;

export const useSurveyIntegrationConfig = () => {
    const orgId = getOrgId();
    return useQuery({
        queryKey: surveyIntegrationConfigKey(orgId),
        queryFn: surveyIntegrationApi.getConfig,
    });
};

export const useUpdateSurveyIntegrationApiKey = () => {
    const queryClient = useQueryClient();
    const orgId = getOrgId();

    return useMutation({
        mutationFn: (apiKey: string) => surveyIntegrationApi.updateApiKey(apiKey),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: surveyIntegrationConfigKey(orgId) });
        },
    });
};

export const useTestSurveyIntegrationConnection = () => {
    const queryClient = useQueryClient();
    const orgId = getOrgId();

    return useMutation({
        mutationFn: surveyIntegrationApi.testConnection,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: surveyIntegrationConfigKey(orgId) });
        },
    });
};

export const useUpdateSurveyIntegrationRouting = () => {
    const queryClient = useQueryClient();
    const orgId = getOrgId();

    return useMutation({
        mutationFn: (enabled: boolean) => surveyIntegrationApi.updateRouting(enabled),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: surveyIntegrationConfigKey(orgId) });
        },
    });
};
